import React from "react";

function RecurringScheduleFilter({

    filters,

    onChange,

    onSearch,

    onReset

}) {

    return (

        <div className="card mb-3">

            <div className="card-body">

                <div className="row g-3">

                    <div className="col-md-4">

                        <label className="form-label">

                            Search

                        </label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Schedule Name..."
                            value={filters.search}
                            onChange={(e) =>
                                onChange(
                                    "search",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                    <div className="col-md-2">

                        <label className="form-label">

                            Work Mode

                        </label>

                        <select
                            className="form-select"
                            value={filters.work_mode}
                            onChange={(e) =>
                                onChange(
                                    "work_mode",
                                    e.target.value
                                )
                            }
                        >

                            <option value="">

                                All

                            </option>

                            <option value="ADHOC">

                                Adhoc

                            </option>

                            <option value="TEMPLATE">

                                Template

                            </option>

                        </select>

                    </div>

                    <div className="col-md-2">

                        <label className="form-label">

                            Frequency

                        </label>

                        <select
                            className="form-select"
                            value={filters.frequency}
                            onChange={(e) =>
                                onChange(
                                    "frequency",
                                    e.target.value
                                )
                            }
                        >

                            <option value="">

                                All

                            </option>

                            <option value="DAILY">

                                Daily

                            </option>

                            <option value="WEEKLY">

                                Weekly

                            </option>

                            <option value="MONTHLY">

                                Monthly

                            </option>

                        </select>

                    </div>

                    <div className="col-md-2">

                        <label className="form-label">

                            Status

                        </label>

                        <select
                            className="form-select"
                            value={filters.status}
                            onChange={(e) =>
                                onChange(
                                    "status",
                                    e.target.value
                                )
                            }
                        >

                            <option value="">

                                All

                            </option>

                            <option value="ACTIVE">

                                Active

                            </option>

                            <option value="PAUSED">

                                Paused

                            </option>

                            <option value="CANCELLED">

                                Cancelled

                            </option>

                        </select>

                    </div>

                    <div
                        className="col-md-2 d-flex align-items-end gap-2"
                    >

                        <button
                            className="btn btn-primary w-100"
                            onClick={onSearch}
                        >

                            Search

                        </button>

                        <button
                            className="btn btn-secondary"
                            onClick={onReset}
                        >

                            Reset

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default RecurringScheduleFilter;